export function WorkspacePage({ className = "", density = "default", children }) {
  return (
    <div
      className={`ds-workspace-page ${
        density === "compact" ? "ds-density--compact" : "ds-density--default"
      }`}
    >
      <div className={`ds-workspace${className ? ` ${className}` : ""}`}>
        {children}
      </div>
    </div>
  );
}

export function FilterPanel({ as: Tag = "section", className = "", children, ...props }) {
  return (
    <Tag className={`ds-filter-panel${className ? ` ${className}` : ""}`} {...props}>
      {children}
    </Tag>
  );
}

export function WorkspaceSection({
  as: Tag = "section",
  title,
  aside,
  className = "",
  bodyClassName = "",
  children,
}) {
  return (
    <Tag className={`ds-workspace-section${className ? ` ${className}` : ""}`}>
      {title || aside ? (
        <div className="ds-workspace-section__header">
          {title ? (
            <div>
              <h2>{title}</h2>
            </div>
          ) : null}
          {aside ? <div className="ds-workspace-section__aside">{aside}</div> : null}
        </div>
      ) : null}
      <div className={`ds-workspace-section__body${bodyClassName ? ` ${bodyClassName}` : ""}`}>
        {children}
      </div>
    </Tag>
  );
}
